/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
import {
  Component,
  Input,
  OnInit,
  SimpleChanges,
  OnChanges,
  TemplateRef,
  ViewChild,
  ChangeDetectionStrategy
} from '@angular/core';
import { DataTableHeader } from '../../../../data-table/DataTableHeader';
import { FRAUDTYPE_MAPPINGS, FRAUDTYPE_TOOLTIPS } from '../CTV_DETAILS_CONFIG';
import { CustomItemContext } from 'app/components/data-table/data-table.component';

@Component({
  selector: 'app-ctv-app-spoofing',
  templateUrl: './ctv-app-spoofing.component.html',
  styleUrls: ['./ctv-app-spoofing.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CtvAppSpoofingComponent implements OnInit, OnChanges {
  @Input() data;
  @Input() isFollowing: boolean;
  @Input() isFreemium: boolean;

  byAppsHeaders: Array<DataTableHeader>;
  byOverallMaxValueMapping: any;
  byIvtMaxValueMapping: any;
  bySellersData = [];
  fraudTypeMappings = FRAUDTYPE_MAPPINGS;
  fraudTypeTooltips = FRAUDTYPE_TOOLTIPS;
  subDataTables = [];

  @ViewChild('sellerNameTemplate')
  sellerNameTemplate: TemplateRef<CustomItemContext>;
  @ViewChild('declaredBundleIdTemplate')
  declaredBundleIdTemplate: TemplateRef<CustomItemContext>;
  @ViewChild('detectedBundleIdTemplate')
  detectedBundleIdTemplate: TemplateRef<CustomItemContext>;

  freemiumData = [
    {
      declaredBundleId: '123',
      detectedBundleId: '1415',
      totalInventoryRatio: '16'
    }
  ];

  ngOnInit(): void {
    this.byAppsHeaders = [];
    this.byAppsHeaders.push({
      class: 'col-3',
      text: 'Declared Bundle ID',
      key: 'declaredBundleId',
      tooltipkey: '',
      lockedInFreemium: this.isFreemium
    });
    this.byAppsHeaders.push({
      class: 'col-3',
      text: 'Detected Bundle ID',
      key: 'detectedBundleId',
      tooltipkey: '',
      lockedInFreemium: this.isFreemium
    });
    this.byAppsHeaders.push({
      class: 'col-2 text-xs-right',
      text: 'SOV',
      key: 'totalInventoryRatio',
      tooltipkey: '',
      format: 'percentRating',
      lockedInFreemium: this.isFreemium
    });
    this.byOverallMaxValueMapping = {};
    this.byIvtMaxValueMapping = {};
  }

  ngOnChanges(changes: SimpleChanges): void {
    for (const propName in changes) {
      if (propName === 'data') {
        this.initData();
      }
    }
  }

  isNotEmpty(arr: Array<any>) {
    return arr && arr.length > 0;
  }

  prepareOverlapStat(appSpoofingStat: any, maxValueMapping: any) {
    if (appSpoofingStat.sellerId) {
      appSpoofingStat.sellerNameTemplate = this.sellerNameTemplate;
    }

    if (
      appSpoofingStat.appSpoofingRate &&
      maxValueMapping['appSpoofingRate'] < appSpoofingStat.appSpoofingRate
    ) {
      maxValueMapping['appSpoofingRate'] = appSpoofingStat.appSpoofingRate;
    }
    if (
      appSpoofingStat.givtSivtRate &&
      maxValueMapping['givtSivtRate'] < appSpoofingStat.givtSivtRate
    ) {
      maxValueMapping['givtSivtRate'] = appSpoofingStat.givtSivtRate;
    }
    if (
      appSpoofingStat.totalInventoryRatio &&
      maxValueMapping['totalInventoryRatio'] <
        appSpoofingStat.totalInventoryRatio
    ) {
      maxValueMapping['totalInventoryRatio'] =
        appSpoofingStat.totalInventoryRatio;
    }
    let rating = 'low';
    if (
      appSpoofingStat.totalInventoryRatio > 0.35 &&
      appSpoofingStat.totalInventoryRatio < 0.65
    ) {
      rating = 'medium';
    } else if (appSpoofingStat.totalInventoryRatio > 0.65) {
      rating = 'high';
    }
    appSpoofingStat['totalInventoryRatioRating'] = rating;

    appSpoofingStat.declaredBundleIdTemplate = this.declaredBundleIdTemplate;
    appSpoofingStat.detectedBundleIdTemplate = this.detectedBundleIdTemplate;
  }

  initData() {
    this.byOverallMaxValueMapping = {};

    if (this.data.spoofingByAppDistribution) {
      this.data.spoofingByAppDistribution.appsByFraudType.forEach(
        appByFraudType => {
          const fraudType = appByFraudType.fraudType;
          let foundTable = this.subDataTables.filter(
            table => table.key === fraudType
          );
          if (!foundTable || !foundTable[0]) {
            const textMapping = this.fraudTypeMappings[fraudType];
            const tooltip = this.fraudTypeTooltips[fraudType];
            foundTable = [
              {
                key: fraudType,
                text: textMapping ? textMapping : fraudType,
                tooltip: tooltip,
                addClass: appByFraudType.skipDetectedBundleId
                  ? 'skipDetectedBundleId'
                  : '',
                data: []
              }
            ];
            this.subDataTables.push(foundTable[0]);
          }

          if (!this.isFreemium) {
            if (foundTable && foundTable[0]) {
              foundTable[0].data = appByFraudType.apps;
              this.byOverallMaxValueMapping[foundTable[0].key] = {};
              this.byOverallMaxValueMapping[foundTable[0].key][
                'appSpoofingRate'
              ] = 0;
              this.byOverallMaxValueMapping[foundTable[0].key][
                'totalInventoryRatio'
              ] = 0;

              foundTable[0].data.forEach(app => {
                this.prepareOverlapStat(
                  app,
                  this.byOverallMaxValueMapping[foundTable[0].key]
                );
              });
            }
          }
        }
      );
    }
  }
}
